// extracted by mini-css-extract-plugin
export default {"form":"ChangeForm__form--Miq","error":"ChangeForm__error--2cq","captcha":"ChangeForm__captcha--wKa"};